import { render, staticRenderFns } from "./TagsTable.vue?vue&type=template&id=775dd939&scoped=true"
import script from "./TagsTable.vue?vue&type=script&lang=ts"
export * from "./TagsTable.vue?vue&type=script&lang=ts"
import style0 from "./TagsTable.vue?vue&type=style&index=0&id=775dd939&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "775dd939",
  null
  
)

export default component.exports